import React from 'react';
import { Link } from 'react-router';

import styles from './List.css';

function SettingHyperlink() {
  return (
    <div className={styles['container-hyperlink']}>
      <span>
        To set stock limit for out of stock items in your POS during checkout,{' '}
      </span>
      <Link
        className={styles['checkout-setting-link']}
        to={'/settings/checkout'}
      >
        click here
      </Link>
    </div>
  );
}

export default SettingHyperlink;
